import { ApolloError } from '@apollo/client'
import { useMemo } from 'react'
import { useAdGroupBudgetHistoryQuery } from '../../../../../__generated__/graphql'
import { BUDGET_HISTORY_DAYS } from './budgetHistoryRange'
import { AdGroupBudgetHistoryEntry } from './budgetHistoryTypes'

export const useAdGroupBudgetHistory = (
  adGroupId: number | string
): {
  changes: AdGroupBudgetHistoryEntry[]
  loading: boolean
  error: ApolloError | undefined
} => {
  const { data, loading, error } = useAdGroupBudgetHistoryQuery({
    variables: { adGroupId, days: BUDGET_HISTORY_DAYS },
    fetchPolicy: 'cache-first',
  })

  const changes = useMemo(() => data?.adGroupBudgetHistory ?? [], [data?.adGroupBudgetHistory])

  return { changes, loading, error }
}
